// Safe localStorage wrapper to prevent crashes in private browsing mode or restrictive environments
const safeStorage = {
  getItem(key) {
    try {
      return localStorage.getItem(key);
    } catch (e) {
      console.warn("localStorage.getItem failed:", e);
      return null;
    }
  },
  setItem(key, value) {
    try {
      localStorage.setItem(key, value);
    } catch (e) {
      console.warn("localStorage.setItem failed:", e);
    }
  },
  removeItem(key) {
    try {
      localStorage.removeItem(key);
    } catch (e) {
      console.warn("localStorage.removeItem failed:", e);
    }
  }
};

const prefillData = {
  "uhr": { "handle": "c209" }, // BITTE HANDLE PRÜFEN, falls es nicht c-209 ist
  "schmuckscheibe": { "handle": "e15" },
  "schmuckscheibe2": { "handle": "k50u" }, // BITTE HANDLE PRÜFEN, falls es nicht k-50u ist
  "uhrenband": { "handle": "us4" }
};

// NEU: skipUpdate Parameter verhindert Endlosschleifen
function addToCustomizer(type, name, img, productid, price, handle = null, skipUpdate = false) {
  if (!handle) {
    console.warn(`WICHTIG: Kein Handle übergeben für ${name}! Bitte passe den Button-Code an.`);
  }

  safeStorage.setItem(type, JSON.stringify({ 'name': name, 'img': img, 'productid': productid, 'price': price, 'handle': handle }));

  if (!skipUpdate) {
    updateCustomizer();
  }
}

function removeAllFromCustomizer() {
  safeStorage.removeItem('uhr');
  safeStorage.removeItem('schmuckscheibe');
  safeStorage.removeItem('schmuckscheibe2');
  safeStorage.removeItem('uhrenband');
  updateCustomizer();
  updateCustomizerList();
}

function updateCustomizer() {
  let uhr = null;
  let schmuckscheibe = null;
  let schmuckscheibe2 = null;
  let uhrenband = null;

  try {
    uhr = JSON.parse(safeStorage.getItem('uhr'));
    schmuckscheibe = JSON.parse(safeStorage.getItem('schmuckscheibe'));
    schmuckscheibe2 = JSON.parse(safeStorage.getItem('schmuckscheibe2'));
    uhrenband = JSON.parse(safeStorage.getItem('uhrenband'));
  } catch (e) {
    console.error("Error parsing storage items:", e);
  }

  // Auto-Korrektur: Verhindert alte fehlerhafte Speicherstände
  if (uhr && !uhr.handle) { safeStorage.removeItem('uhr'); uhr = null; }
  if (schmuckscheibe && !schmuckscheibe.handle) { safeStorage.removeItem('schmuckscheibe'); schmuckscheibe = null; }
  if (schmuckscheibe2 && !schmuckscheibe2.handle) { safeStorage.removeItem('schmuckscheibe2'); schmuckscheibe2 = null; }
  if (uhrenband && !uhrenband.handle) { safeStorage.removeItem('uhrenband'); uhrenband = null; }

  const imgUhr = document.getElementsByClassName('customizer')[0]?.getElementsByClassName('uhr')[0];
  const imgSchmuckscheibe1 = document.getElementsByClassName('customizer')[0]?.getElementsByClassName('schmuckscheibe1')[0];
  const imgSchmuckscheibe2 = document.getElementsByClassName('customizer')[0]?.getElementsByClassName('schmuckscheibe2')[0];
  const imgUhrenband = document.getElementsByClassName('customizer')[0]?.getElementsByClassName('uhrenband')[0];

  // NEU: Diese Funktion rettet den Konfigurator, wenn ein Bild defekt ist!
  // Das Bild wird unsichtbar gemacht, aber der Artikel wird NICHT mehr gelöscht.
  const handleImageFallback = (imgEl, type, errorMsg) => {
    console.warn("Bild-Ladefehler abgefangen:", errorMsg);
    imgEl.onerror = null;
    imgEl.src = 'data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=';
  };

  if (uhr && imgUhr) {
    // Wir überschreiben das HTML-onError, um die automatische Löschung zu stoppen
    imgUhr.onerror = () => handleImageFallback(imgUhr, 'uhr', `Uhr Bild URL ungültig: ${uhr.img}`);
    imgUhr.onload = () => addToCustomizerForm('uhr', uhr.productid, 0);
    imgUhr.src = uhr.img;
  } else if (imgUhr) {
    imgUhr.onerror = null;
    imgUhr.onload = null;
    imgUhr.src = 'data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=';
  }

  if (schmuckscheibe && imgSchmuckscheibe1) {
    imgSchmuckscheibe1.onerror = () => handleImageFallback(imgSchmuckscheibe1, 'schmuckscheibe', `Schmuck 1 Bild URL ungültig: ${schmuckscheibe.img}`);
    imgSchmuckscheibe1.onload = () => addToCustomizerForm('schmuckscheibe', schmuckscheibe.productid, 1);
    imgSchmuckscheibe1.src = schmuckscheibe.img;
  } else if (imgSchmuckscheibe1) {
    imgSchmuckscheibe1.onerror = null;
    imgSchmuckscheibe1.onload = null;
    imgSchmuckscheibe1.src = 'data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=';
  }

  if (schmuckscheibe2 && imgSchmuckscheibe2) {
    imgSchmuckscheibe2.onerror = () => handleImageFallback(imgSchmuckscheibe2, 'schmuckscheibe2', `Schmuck 2 Bild URL ungültig: ${schmuckscheibe2.img}`);
    imgSchmuckscheibe2.onload = () => addToCustomizerForm('schmuckscheibe2', schmuckscheibe2.productid, 2);
    imgSchmuckscheibe2.src = schmuckscheibe2.img;
  } else if (imgSchmuckscheibe2) {
    imgSchmuckscheibe2.onerror = null;
    imgSchmuckscheibe2.onload = null;
    imgSchmuckscheibe2.src = 'data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=';
  }

  if (uhrenband && imgUhrenband) {
    imgUhrenband.onerror = () => handleImageFallback(imgUhrenband, 'uhrenband', `Band Bild URL ungültig: ${uhrenband.img}`);
    imgUhrenband.onload = () => addToCustomizerForm('uhrenband', uhrenband.productid, 3);
    imgUhrenband.src = uhrenband.img;
  } else if (imgUhrenband) {
    imgUhrenband.onerror = null;
    imgUhrenband.onload = null;
    imgUhrenband.src = 'data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=';
  }

  calculatePrice();
  updateCustomizerList();
}

async function calculatePrice() {
  let uhrObj = null;
  let schmuckObj = null;
  let schmuck2Obj = null;
  let bandObj = null;

  try {
    uhrObj = JSON.parse(safeStorage.getItem('uhr'));
    schmuckObj = JSON.parse(safeStorage.getItem('schmuckscheibe'));
    schmuck2Obj = JSON.parse(safeStorage.getItem('schmuckscheibe2'));
    bandObj = JSON.parse(safeStorage.getItem('uhrenband'));
  } catch (e) {
    console.error("Error parsing storage items for price calculation:", e);
  }

  let uhrPrice = uhrObj?.price ? uhrObj.price : 0;
  let schmuckPrice = schmuckObj?.price ? schmuckObj.price : 0;
  let schmuck2Price = schmuck2Obj?.price ? schmuck2Obj.price : 0;
  let bandPrice = bandObj?.price ? bandObj.price : 0;

  if (window.isB2BMerchant) {
    const handlesToFetch = [];
    if (uhrObj?.handle && !window.b2bProductData?.[uhrObj.handle]) handlesToFetch.push(uhrObj.handle);
    if (schmuckObj?.handle && !window.b2bProductData?.[schmuckObj.handle]) handlesToFetch.push(schmuckObj.handle);
    if (schmuck2Obj?.handle && !window.b2bProductData?.[schmuck2Obj.handle]) handlesToFetch.push(schmuck2Obj.handle);
    if (bandObj?.handle && !window.b2bProductData?.[bandObj.handle]) handlesToFetch.push(bandObj.handle);

    if (handlesToFetch.length > 0) {
      window.b2bKnownHandles = window.b2bKnownHandles || new Set();
      const newHandles = handlesToFetch.filter(h => !window.b2bKnownHandles.has(h));
      if (newHandles.length > 0) {
        try {
          const res = await fetch('/apps/dejavu/proxy', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ intent: "get_b2b_prices", handles: newHandles })
          });
          const data = await res.json();
          if (data.products) {
            window.b2bProductData = window.b2bProductData || {};
            Object.assign(window.b2bProductData, data.products);
          }
          newHandles.forEach(h => window.b2bKnownHandles.add(h));
        } catch (e) { console.error("B2B Konfigurator Fehler:", e); }
      }
    }

    const getB2bPriceInCent = (obj, defaultPriceInCent) => {
      if (obj?.handle && window.b2bProductData?.[obj.handle]) {
        const b2bDbPrice = parseFloat(window.b2bProductData[obj.handle].b2bPrice);
        if (!isNaN(b2bDbPrice)) return Math.round(b2bDbPrice * 100);
      }
      return defaultPriceInCent;
    };

    uhrPrice = getB2bPriceInCent(uhrObj, uhrPrice);
    schmuckPrice = getB2bPriceInCent(schmuckObj, schmuckPrice);
    schmuck2Price = getB2bPriceInCent(schmuck2Obj, schmuck2Price);
    bandPrice = getB2bPriceInCent(bandObj, bandPrice);
  }

  let allItemsApplied = uhrPrice !== 0 && schmuckPrice !== 0 && schmuck2Price !== 0 && bandPrice !== 0;
  let price = ((uhrPrice + schmuckPrice + schmuck2Price + bandPrice) / 100);

  let priceContainer = document.getElementById('customizerPrice');
  let discountContainer = document.getElementById('discountPriceContainer');
  let discountPriceEl = document.getElementById('discountPrice');

  if (priceContainer && priceContainer.parentElement) {
    priceContainer.parentElement.style.display = 'none';
  }
  
  if (discountContainer) {
    discountContainer.hidden = false;
    discountContainer.style.cssText += " display: block;";
  }
  
  if (discountPriceEl) {
    const formattedPrice = price.toLocaleString("de-DE", { style: "currency", currency: "EUR" });
    
    if (window.isB2BMerchant) {
      discountPriceEl.innerHTML = `${formattedPrice} <span style="font-size: 0.6em; background: #ffdce0; padding: 2px 6px; border-radius: 4px; color: #d82c0d; vertical-align: middle; margin-left: 4px;">B2B</span>`;
    } else {
      discountPriceEl.innerHTML = formattedPrice;
    }
  }
}

function addToCustomizerForm(type, productid, index) {
  const form = document.getElementById("customizer-form");
  if (!form) return;
  let productIdInput = form.querySelector(`.product-variant-id.${type}`);
  if (productIdInput) {
    productIdInput.value = productid;
  } else {
    form.insertAdjacentHTML('beforeend', `<input type="hidden" name="items[${index}][id]" value="${productid}" class="product-variant-id ${type}">`);
    form.insertAdjacentHTML('beforeend', `<input type="hidden" name="items[${index}][quantity]" value="1" class="product-quantity ${type}">`);
  }
}

function removeFromCustomizer(type, classIdentifier) {
  const form = document.getElementById("customizer-form");
  let imagesContainer = document.getElementsByClassName('customizer-images')[0];
  if (imagesContainer) {
    let imgEl = imagesContainer.querySelector(`.${classIdentifier}`);
    if (imgEl) {
      imgEl.onerror = null;
      imgEl.onload = null;
      imgEl.src = 'data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=';
    }
  }
  if (form) form.querySelectorAll(`.${type}`).forEach(e => e.remove());
  safeStorage.removeItem(type);
  calculatePrice();
  updateCustomizerList();
}

function swapSchmuckscheiben() {
  let s1 = safeStorage.getItem('schmuckscheibe');
  let s2 = safeStorage.getItem('schmuckscheibe2');
  
  if (s1) safeStorage.setItem('schmuckscheibe2', s1);
  else safeStorage.removeItem('schmuckscheibe2');
  
  if (s2) safeStorage.setItem('schmuckscheibe', s2);
  else safeStorage.removeItem('schmuckscheibe');
  
  updateCustomizer();
}

function updateCustomizerList() {
  const listContainer = document.getElementById('customizer-selected-list');
  if (!listContainer) return;

  let uhr = null;
  let schmuckscheibe = null;
  let schmuckscheibe2 = null;
  let uhrenband = null;

  try {
    uhr = JSON.parse(safeStorage.getItem('uhr'));
    schmuckscheibe = JSON.parse(safeStorage.getItem('schmuckscheibe'));
    schmuckscheibe2 = JSON.parse(safeStorage.getItem('schmuckscheibe2'));
    uhrenband = JSON.parse(safeStorage.getItem('uhrenband'));
  } catch (e) {
    console.error("Error parsing storage items for list update:", e);
  }

  let html = '<ul style="list-style: none; padding: 0; margin: 5px 0 5px 0; width: 100%;">';
  
  const createListItem = (item, type, classIdentifier, label) => {
    if (!item) return '';
    let itemUrl = item.handle ? `/products/${item.handle}` : '#';
    return `
      <li style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 6px; font-size: 1.2rem; border-bottom: 1px solid rgba(0,0,0,0.1); padding-bottom: 4px;">
        <div style="width: 85%; overflow: hidden; white-space: nowrap; text-overflow: ellipsis;">
          <a href="${itemUrl}" style="text-decoration: none; color: #333; font-weight: 600; line-height: 1.4;" title="${item.name.replace(/"/g, '&quot;')}">${item.name}</a>
          <span style="font-size: 1rem; color: #666; line-height: 1.4; margin-left: 4px;">- ${label}</span>
        </div>
        <button type="button" onclick="removeFromCustomizer('${type}', '${classIdentifier}')" style="background: transparent; border: none; font-size: 1.8rem; cursor: pointer; color: #ee300f; padding: 0 5px; line-height: 1;" title="Entfernen">&times;</button>
      </li>
    `;
  };

  html += createListItem(uhr, 'uhr', 'uhr', 'Uhr');
  html += createListItem(schmuckscheibe, 'schmuckscheibe', 'schmuckscheibe1', 'Schmuckscheibe (Oben)');
  html += createListItem(schmuckscheibe2, 'schmuckscheibe2', 'schmuckscheibe2', 'Schmuckscheibe (Unten)');
  html += createListItem(uhrenband, 'uhrenband', 'uhrenband', 'Uhrenband');

  if (schmuckscheibe || schmuckscheibe2) {
    html += `
      <li style="text-align: center; margin-top: 4px; border: none;">
        <button type="button" onclick="swapSchmuckscheiben()" class="button button--secondary" style="min-height: 26px; height: 26px; font-size: 1.1rem; padding: 0 10px; width: 100%; display: flex; justify-content: center; align-items: center; gap: 5px;">
          &#8645; Scheiben tauschen
        </button>
      </li>
    `;
  }

  html += '</ul>';
  listContainer.innerHTML = html;
}

function closeCustomizer() {
  let customizer = document.getElementById('customizer');
  let productgrid = document.getElementById('product-grid');
  if (customizer) customizer.classList.add('closed');
  if (productgrid) {
    productgrid.classList.remove('grid--4-col-desktop');
    productgrid.classList.add('grid--5-col-desktop');
  }
}

function openCustomizer() {
  let customizer = document.getElementById('customizer');
  let productgrid = document.getElementById('product-grid');
  if (customizer) customizer.classList.remove('closed');
  if (productgrid) {
    productgrid.classList.add('grid--4-col-desktop');
    productgrid.classList.remove('grid--5-col-desktop');
  }
}

async function initCustomizer() {
  const types = ['uhr', 'schmuckscheibe', 'schmuckscheibe2', 'uhrenband'];
  
  // Lade die Prefill-Daten immer im Hintergrund, damit sie bereitliegen,
  // falls der Nutzer seine aktuelle Auswahl löscht.
  const fetchPromises = types.map(async (type) => {
    if (prefillData[type] && prefillData[type].handle) {
      try {
        let res = await fetch('/products/' + prefillData[type].handle + '.js');
        if (res.ok) {
          let product = await res.json();
          prefillData[type].productId = product.variants[0].id;
          prefillData[type].price = product.price;
          prefillData[type].productImage = product.featured_image;
          prefillData[type].productName = product.title;
        } else {
          console.warn(`Standard-Produkt ${prefillData[type].handle} konnte nicht geladen werden.`);
        }
      } catch (e) {
        console.error(`Fehler beim Laden von ${prefillData[type].handle}:`, e);
      }
    }
  });

  // Warte bis alle Standard-Produkte geladen sind
  await Promise.all(fetchPromises);
  
  // Prefill nur, wenn noch kein Element im Customizer konfiguriert ist
  const hasSavedConfig = types.some(type => safeStorage.getItem(type) !== null);
  if (!hasSavedConfig) {
    types.forEach(type => {
      if (prefillData[type] && prefillData[type].productId) {
        safeStorage.setItem(type, JSON.stringify({
          'name': prefillData[type].productName,
          'img': prefillData[type].productImage,
          'productid': prefillData[type].productId,
          'price': prefillData[type].price,
          'handle': prefillData[type].handle
        }));
      }
    });
  }
  
  updateCustomizer();
}

document.addEventListener("DOMContentLoaded", function () {
  initCustomizer();
});

// Safari bfcache back-button support: re-run configuration update on pageshow
window.addEventListener("pageshow", function (event) {
  updateCustomizer();
});

function getHighResUrl(url) {
  if (!url) return '';
  // Ersetzt width=400 (falls vorhanden) durch width=2000 für eine gestochen scharfe Großansicht
  return url.replace(/width=\d+/, 'width=2000');
}

function openConfiguratorLightbox(opener) {
  const lbUhrenband = document.getElementById('lbUhrenband');
  const lbSchmuckscheibe = document.getElementById('lbSchmuckscheibe');
  const lbSchmuckscheibe2 = document.getElementById('lbSchmuckscheibe2');
  const lbUhr = document.getElementById('lbUhr');

  if (lbUhrenband) lbUhrenband.src = getHighResUrl(document.getElementById('customUhrenband').src);
  if (lbSchmuckscheibe) lbSchmuckscheibe.src = getHighResUrl(document.getElementById('customSchmuckscheibe').src);
  if (lbSchmuckscheibe2) lbSchmuckscheibe2.src = getHighResUrl(document.getElementById('customSchmuckscheibe2').src);
  if (lbUhr) lbUhr.src = getHighResUrl(document.getElementById('customUhr').src);

  const modal = document.getElementById('ConfiguratorLightbox');
  if (modal && typeof modal.show === 'function') {
    const lightboxImages = modal.querySelector('.lightbox-images');
    if (lightboxImages) {
      // Berechne den maximalen Scale-Faktor, um 95% des Bildschirms auszufüllen.
      // Basisgröße des Bildcontainers ist 250px mal 600px
      const availableHeight = window.innerHeight * 0.95;
      const availableWidth = window.innerWidth * 0.95;
      const scaleByHeight = availableHeight / 600;
      const scaleByWidth = availableWidth / 250;
      
      // Wähle den kleineren Faktor, damit die Uhr garantiert ohne Abschneiden reinpasst
      const maxScale = Math.min(scaleByHeight, scaleByWidth);
      
      lightboxImages.style.transform = `scale(${maxScale})`;
      lightboxImages.style.transition = 'transform 0.3s ease-out';
    }
    
    modal.show(opener);
  }
}
